const dragDropFile = {
  upload: {
    drag: 'Drop your file here or',
    browse: 'browse your files.',
  },

  uploaded: {
    success: 'File {{name}} was succesfully uploaded',
    chooseAnotherFile: 'Choose a different file.',
  },
};

export default dragDropFile;
